import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { DateInput } from 'components/layout/form-fields/inputs/DateInput';
import { shift } from '@floating-ui/dom';
import { FormField as FormikFormField } from 'components/layout/form-fields/FormField';
import { UsersDropdown } from 'components/layout/form-fields/inputs/UsersDropdown';
import { applicantStore } from '../ApplicantStore';
import { eventManager } from 'ats/utils/EventManager';
import { FormField } from 'components/layout/modals/components';
import { FormColumn } from 'components/layout/modals/components/FormColumn';
import { ApplicantDropdown } from 'components/layout/form-fields/inputs/ApplicantDropdown';
import Dropdown from 'ats/components/dropdown/Dropdown';
import { getApplicantTaskDropdownOptions } from 'ats/utils/applicantTaskTheme';
import { authStore } from 'shared/security/AuthStore';
import { NON_CANDIDATE_USER_ROLES } from 'shared/security/RolesAllowed';

const ValidationSchema = Yup.object().shape({
	description: Yup.string().label('Description'),
	type: Yup.object().label('Type').required(),
	scheduledDate: Yup.string().label('Scheduled Date').nullable(),
	assignments: Yup.array().nullable().label('Assignments')
});

export class ApplicantTaskCreate extends ModalComponent {
	static isV2 = true;

	getInitialValues() {
		return {
			description: '',
			type: null,
			scheduledDate: null,
			assignments: authStore.profile ? [authStore.profile] : []
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'ApplicantTaskCreate')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<FormField label="Task" required error={formikBag.errors.type}>
					<Dropdown
						value={formikBag.values.type}
						onChange={item => {
							formikBag.setFieldValue('type', item);
						}}
						options={getApplicantTaskDropdownOptions(
							applicantStore.taskOptions
						)}
						menuClassName="job-task-type-menu"
						placeholder=" "
					/>
				</FormField>
				{applicantStore.schedulableTaskTypes.includes(
					formikBag.values.type?.value
				) ? (
					<FormField
						label="Scheduled Date"
						error={formikBag.errors.scheduledDate}>
						<DateInput
							value={formikBag.values.scheduledDate}
							popperPlacement="top-start"
							popperModifiers={[
								shift({
									padding: 5,
									crossAxis: true
								})
							]}
							onBlur={() => formikBag.setFieldTouched('scheduledDate')}
							onChange={newDate => {
								formikBag.setFieldValue('scheduledDate', newDate);
							}}
							isDateTime
						/>
					</FormField>
				) : null}
				<FormField label="Candidate">
					<ApplicantDropdown
						placeholder="Candidate"
						value={this.props.applicant}
						showAvatar
						disabled
					/>
				</FormField>
				<FormField label="Assigned to" error={formikBag.errors.assignments}>
					<UsersDropdown
						value={formikBag.values.assignments}
						isMulti
						placeholder=" "
						role={NON_CANDIDATE_USER_ROLES}
						onValueChange={values => {
							formikBag.setFieldValue('assignments', values);
						}}
						showAvatar
					/>
				</FormField>
				<FormColumn>
					<label className="form-field-label-outside">Description</label>
					<FormField error={formikBag.errors.description}>
						<FormikFormField
							className="has-text-left"
							field="description"
							type="textarea"
							placeholder="Description"
							maxlength={2500}
						/>
					</FormField>
				</FormColumn>
			</Fragment>
		);
	}

	async create(values) {
		applicantStore
			.createTask(this.props.applicant.id, {
				description: values.description,
				type: values.type.value,
				scheduledDate: applicantStore.schedulableTaskTypes.includes(
					values.type?.value
				)
					? values.scheduledDate
					: null,
				assignments: values.assignments.map(assignment => assignment.id)
			})
			.then(result => {
				if (result.status === 'success') {
					eventManager.emit('taskChanged');
				}
				this.resultNotification(result, 'Task', 'Create');
			});
	}
}
